export default __webpack_public_path__ + "static/media/logo_afts.aa625ed8.png";